import {UserOPEEnum} from "./UserOPEEnum";
import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";

// Same shape as the BE GetUsersCB.O.UserDTO, which this ope reuses.
class UserDTO {
  public id!: number;
  public username!: string;
  public email!: string;
  public firstname!: string;
  public lastname!: string;
  public language?: string;
  public roles!: string[];
  public partitionId!: number;
  public partitionName!: string;
  public enabled?: boolean;
  linkedPartitions?: number[];
  welcomeSent!: boolean;
}

/**
 * O Inner Class
 */
class O {
  users!: UserDTO[];
}

/**
 * I Inner Class
 */
class I {
}

/**
 * Users visible to the authenticated user across their whole partition hierarchy, themselves
 * included: unlike getUsers it takes no partitionId and returns only users whose role priority
 * is equal to or lower than the caller's. Meant for the recipient selector of
 * shareDashboard/shareDashboardWidget.
 */
export class GetVisibleUsersCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.GetVisibleUsers);
    this.i = new I();
    this.o = new O();
  }
}
